module.exports = "<div class=\"vs\" [ngStyle]=\"vsStyle\" (scroll)=\"scroll($event)\" #vs>\n  <ng-container *ngFor=\"let row of getD(); let i = index\">\n    <div [ngStyle]=\"getRowStyle(row.index)\">\n      <ng-container *ngTemplateOutlet=\"template; context: {'row': row.item,'index':i}\"></ng-container>\n    </div>\n  </ng-container>\n  <div id=\"scrollr\" [ngStyle]=\"scrollStyle\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/virtual-scroll/virtual-scroll.component.html
// module id = ./src/app/modules/virtual-scroll/virtual-scroll.component.html
// module chunks = main